import { render, staticRenderFns } from "./SetModelsDialog.vue?vue&type=template&id=f5ca47a0"
import script from "./SetModelsDialog.vue?vue&type=script&lang=js"
export * from "./SetModelsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports